module.exports = __webpack_public_path__ + "img/about.3cc57fa4.jpg";